import {
  AbstractJsonLexer1em5xl1wqsdtw as AbstractJsonLexer,
  charToTokenClass1wja4xge82waq as charToTokenClass,
  tokenDescription3r6eqmtoxe76u as tokenDescription,
} from './AbstractJsonLexer.mjs';
import {
  charCodeAt1yspne1d8erbm as charCodeAt,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  charSequenceLength3278n89t01tmv as charSequenceLength,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  _Char___init__impl__6a9atx2gndcvjvc5pke as _Char___init__impl__6a9atx,
  toString22rbkbhdb5cl2 as toString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { indexOf1xbs558u7wr52 as indexOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { substringiqarkczpya5m as substring } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { StringJsonLexerWithComments3bzrli3gl2cah as StringJsonLexerWithComments } from './CommentLexers.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var StringJsonLexerClass;
function StringJsonLexer() {
  if (StringJsonLexerClass === VOID) {
    class $ extends AbstractJsonLexer() {
      constructor(source) {
        super();
        this.j2x_1 = source;
      }
      q2w() {
        return this.j2x_1;
      }
      r2w(position) {
        return position < this.q2w().length ? position : -1;
      }
      f2t() {
        var source = this.q2w();
        var cpos = this.s2m_1;
        $l$loop: while (!(cpos === -1) && cpos < source.length) {
          var _unary__edvuaz = cpos;
          cpos = _unary__edvuaz + 1 | 0;
          var c = charCodeAt(source, _unary__edvuaz);
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
          if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9))
            continue $l$loop;
          this.s2m_1 = cpos;
          return charToTokenClass(c);
        }
        this.s2m_1 = source.length;
        return 10;
      }
      b2t() {
        var current = this.s2m_1;
        if (current === -1)
          return false;
        var source = this.q2w();
        $l$loop: while (current < source.length) {
          var c = charCodeAt(source, current);
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
          if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9)) {
            current = current + 1 | 0;
            continue $l$loop;
          }
          this.s2m_1 = current;
          return this.u2w(c);
        }
        this.s2m_1 = current;
        return false;
      }
      t2w() {
        var current = this.s2m_1;
        if (current === -1)
          return current;
        var source = this.q2w();
        $l$loop: while (current < source.length) {
          var c = charCodeAt(source, current);
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
          if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9)) {
            current = current + 1 | 0;
          } else {
            break $l$loop;
          }
        }
        this.s2m_1 = current;
        return current;
      }
      m2t(expected) {
        if (this.s2m_1 === -1) {
          this.v2w(expected);
        }
        var source = this.q2w();
        var cpos = this.s2m_1;
        $l$loop: while (cpos < source.length) {
          var _unary__edvuaz = cpos;
          cpos = _unary__edvuaz + 1 | 0;
          var c = charCodeAt(source, _unary__edvuaz);
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
          if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9))
            continue $l$loop;
          this.s2m_1 = cpos;
          if (c === expected)
            return Unit_instance;
          this.v2w(expected);
        }
        this.s2m_1 = -1;
        this.v2w(expected);
      }
      s2t() {
        this.m2t(_Char___init__impl__6a9atx(34));
        var current = this.s2m_1;
        var closingQuote = indexOf(this.q2w(), _Char___init__impl__6a9atx(34), current);
        if (closingQuote === -1) {
          this.d2t();
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.fail' call
          var expected = tokenDescription(1);
          var position = false ? this.s2m_1 - 1 | 0 : this.s2m_1;
          var s = this.s2m_1 === charSequenceLength(this.q2w()) || position < 0 ? 'EOF' : toString(charSequenceGet(this.q2w(), position));
          var tmp$ret$1 = 'Expected ' + expected + ", but had '" + s + "' instead";
          this.o2r(tmp$ret$1, position);
        }
        var inductionVariable = current;
        if (inductionVariable < closingQuote)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            if (charCodeAt(this.q2w(), i) === _Char___init__impl__6a9atx(92)) {
              return this.consumeString2(this.q2w(), this.s2m_1, i);
            }
          }
           while (inductionVariable < closingQuote);
        this.s2m_1 = closingQuote + 1 | 0;
        return substring(this.q2w(), current, closingQuote);
      }
      u2t(keyToMatch, isLenient) {
        var positionSnapshot = this.s2m_1;
        try {
          if (!(this.f2t() === 6))
            return null;
          var firstKey = this.p2t(isLenient);
          if (!(firstKey === keyToMatch))
            return null;
          this.w2w();
          if (!(this.f2t() === 5))
            return null;
          return this.p2t(isLenient);
        }finally {
          this.s2m_1 = positionSnapshot;
          this.w2w();
        }
      }
    }
    initMetadataForClass($, 'StringJsonLexer');
    StringJsonLexerClass = $;
  }
  return StringJsonLexerClass;
}
function StringJsonLexer_0(json, source) {
  return !json.f2m_1.f2o_1 ? new (StringJsonLexer())(source) : new (StringJsonLexerWithComments())(source);
}
//region block: exports
export {
  StringJsonLexer_0 as StringJsonLexer3eu6xom7mrcfu,
  StringJsonLexer as StringJsonLexervr9dj3kex5li,
};
//endregion

//# sourceMappingURL=StringJsonLexer.mjs.map
